import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, withKeys as _withKeys, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }

import {Component, reactive, ref, watch} from 'vue'
import MotorTypeSelector from "@/components/inputs/motorTypeSelector.vue";
import IsSafetySelect from "@/components/inputs/isSafetySelect.vue";
import {openFilterSyntaxDialog, useGlobalSetting} from "@/lib/utils";
import StateSelect from "@/components/inputs/StateSelect.vue";
import {Groups} from "@/types/Order";
import {Header} from "@/lib/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterForm',
  props: /*@__PURE__*/_mergeModels({
    onClose: { type: Function },
    headers: {},
    fetch: { type: Function }
  }, {
    "modelValue": {},
    "modelModifiers": {},
    "model2": {},
    "model2Modifiers": {},
  }),
  emits: ["update:modelValue", "update:model2"],
  setup(__props: any) {

const model = _useModel(__props, "modelValue");

const sortBy = _useModel(__props, 'model2');

const props = __props

const localModel = ref(JSON.parse(JSON.stringify(model.value)));

const selectedSortField = ref<string>('')
const sortDirectionMap = reactive<Record<string, 'asc' | 'desc'>>({})

const rangeHover = ref<boolean>(false);

selectedSortField.value = sortBy.value[0].key;
sortDirectionMap[selectedSortField.value] = sortBy.value[0].order;

watch(() => model, (newVal) => {
  localModel.value = JSON.parse(JSON.stringify(newVal))
})

const toggleSortDirection = (field: string): void => {
  if (selectedSortField.value === field) {
    if (sortDirectionMap[field] != 'desc') {
      sortDirectionMap[field] = sortDirectionMap[field] === 'asc' ? 'desc' : 'asc'
    } else {
      selectedSortField.value = '';
    }
  } else {
    selectedSortField.value = field
    sortDirectionMap[field] = 'asc'
  }
}

const getSortIcon = (field: string): string => {
  return sortDirectionMap[field] === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down'
}

function applyFilters() {
  sortBy.value[0].key = selectedSortField.value;
  sortBy.value[0].order = sortDirectionMap[selectedSortField.value];
  if (localModel.value != undefined) {
    Object.assign(model.value, localModel.value);
  }
  props.onClose?.();
  props.fetch?.();
}


return (_ctx: any,_cache: any) => {
  const _component_v_range_slider = _resolveComponent("v-range-slider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.headers, (header) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: header.key,
              cols: "12",
              md: "6"
            }, {
              default: _withCtx(() => [
                (header.canBeFiltered == true || header.canBeFiltered == undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      (header.filterComponent)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(header.filterComponent), _mergeProps({
                            key: 0,
                            modelValue: localModel.value[header.key],
                            "onUpdate:modelValue": ($event: any) => ((localModel.value[header.key]) = $event),
                            "prepend-icon": header.icon
                          }, { ref_for: true }, header.filterProps, {
                            disabled: header.disabled
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "prepend-icon", "disabled"]))
                        : (header.key == 'progress')
                          ? (_openBlock(), _createBlock(_component_v_range_slider, {
                              key: 1,
                              modelValue: localModel.value[header.key],
                              "onUpdate:modelValue": ($event: any) => ((localModel.value[header.key]) = $event),
                              step: "1",
                              onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (rangeHover.value = true)),
                              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (rangeHover.value = false)),
                              "thumb-label": rangeHover.value ? 'always' : false,
                              "prepend-icon": header.icon,
                              disabled: header.disabled
                            }, {
                              "thumb-label": _withCtx(({ modelValue }) => [
                                _createTextVNode(_toDisplayString(modelValue) + "% ", 1)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "thumb-label", "prepend-icon", "disabled"]))
                          : (!header.checkbox)
                            ? (_openBlock(), _createBlock(_component_v_text_field, {
                                key: 2,
                                modelValue: localModel.value[header.key],
                                "onUpdate:modelValue": ($event: any) => ((localModel.value[header.key]) = $event),
                                label: `${header.title} enthält`,
                                "prepend-icon": header.icon,
                                clearable: "",
                                onKeydown: _withKeys(applyFilters, ["enter"]),
                                variant: _unref(useGlobalSetting)().globalTextVariant,
                                disabled: header.disabled
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "prepend-icon", "variant", "disabled"]))
                            : (_openBlock(), _createBlock(_component_v_switch, {
                                key: 3,
                                modelValue: localModel.value[header.key],
                                "onUpdate:modelValue": ($event: any) => ((localModel.value[header.key]) = $event),
                                "base-color": "info",
                                color: header.key === 'isSafety' ? 'yellow': 'primary',
                                label: header.title,
                                "prepend-icon": header.icon,
                                density: "compact",
                                "hide-details": "",
                                inset: "",
                                disabled: header.disabled
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "label", "prepend-icon", "disabled"]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mb-2" }, "Sortiere nach", -1)),
              _createVNode(_component_v_chip_group, { column: "" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: header.key
                    }, [
                      (!header.checkbox)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            class: "ma-1",
                            onClick: ($event: any) => (toggleSortDirection(header.key))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(header.title) + " ", 1),
                              (selectedSortField.value === header.key)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    end: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(getSortIcon(header.key)), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1,
            __: [3]
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mt-4" }, {
        default: _withCtx(() => [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(openFilterSyntaxDialog)()), ["prevent"])),
            target: "_blank",
            rel: "noopener",
            class: "link-with-icon text-primary"
          }, [
            _createVNode(_component_v_icon, {
              start: "",
              class: "no-underline"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("mdi-help-circle-outline")
              ])),
              _: 1,
              __: [4]
            }),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "underline-text" }, "Filtersyntax", -1))
          ]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            color: "btnColor",
            variant: _unref(useGlobalSetting)().globalButtonVariant,
            onClick: applyFilters
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: "mdi-filter-outline",
                start: ""
              }),
              _cache[6] || (_cache[6] = _createTextVNode(" Filter anwenden "))
            ]),
            _: 1,
            __: [6]
          }, 8, ["variant"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})